import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchadmininfo } from "../../Redux/Actions/AdmininfoAction";
import { useDispatch } from "react-redux";
import { useAuth } from "../../Context/store/context";
import "../../../css/page-auth.css";
import DocumentTitle from '../../../documentTitle.js';
import config from "../../../config";
import { _get, _post } from "../../../apiClient";
import { _showToast } from "../../../toastHelper";

// function to handle the refresh
export function getRootPath(url) {
  const urlParts = url.split("/");
  return `/${urlParts[1]}`;
}

export default function Registration() {

  //Updating the document title
  DocumentTitle('Register');

  const searchParams = new URLSearchParams(location.search);
  const packageId = searchParams.get("packageId");
  const navigate = useNavigate();

  const [error, setError] = useState({
    phoneNumber: "",
    email: "",
    password: "",
  });

  const dispatch = useDispatch();

  const {
    storeTokens,
    login,
    storePackageParam,
    showLoader,
    hideLoader,
  } = useAuth();

  useEffect(() => {
    if (packageId) {
      storePackageParam(packageId);
    }
  }, [packageId]);

  // handling the regestration page
  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    password: "",
  });

  const handleInputChange = (e) => {
    let { name, value } = e.target;

    let phoneNumberError = "";
    let emailError = "";
    let passwordError = "";

    if (name === "phoneNumber") {
      const phoneNumberPattern = /^[6-9]\d{9}$/;
      if (!phoneNumberPattern.test(value)) {
        phoneNumberError =
          "Invalid phone number. Please enter a valid 10-digit Indian phone number.";
      }

      value = value.replace(/[^0-9]/g, '');
    }

    if (name === "email") {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
      if (!emailPattern.test(value)) {
        emailError = "Invalid email address.";
      }
    }

    if (name === "password") {
      if (value.length < 8) {
        passwordError = "Password must be at least 8 characters long.";
      }
    }

    setError({
      ...error,
      phoneNumber: phoneNumberError,
      email: emailError,
      password: passwordError,
    });

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };


  const handleRegistration = async (e) => {
    e.preventDefault();
    showLoader();
    let userId = await register();

    if (userId > 0)
      await fetchUserDetails();
  };

  async function register() {
    let body = {
      "firstName": formValues.firstName,
      "lastName": formValues.lastName,
      "email": formValues.email != "" ? formValues.email : null,
      "contactNo": formValues.phoneNumber,
      "password": formValues.password
    };

    return await _post(`/app-users`, body, null, false)
      .then(response => {
        storeTokens(response.accessToken, response.refreshToken);
        _showToast("You’ve been registered successfully. Welcome aboard!  ", "success");
        return response.userId;
      }).catch(error => {
        hideLoader();
        _showToast(error, "error");
        return 0;
      });
  }

  const fetchUserDetails = async () => {
    await _get(`/app-users/details`)
      .then(response => {
        login();
        dispatch(fetchadmininfo(response));
        hideLoader();
        return navigate("/dashboard");
      }).catch(error => {
        hideLoader();
        _showToast(error, "error");
        return 0;
      });
  }

  return (
    <div className="authentication-wrapper authentication-cover authentication-bg">
      <div className="authentication-inner row">
        {/* <!-- /Left Text --> */}
        <div className="d-none d-lg-flex col-lg-8 p-0">
          <div className="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center bg1 ">
            <div className="hero-banner hero-style-2 bg-image">
              <div className="banner-gallery">
                <div
                  className="thumbnail thumbnail-1"
                  data-sal-delay="500"
                  data-sal="slide-up"
                  data-sal-duration="1000"
                >
                  <img src="images/birthday_events.jpg" alt="" />
                </div>
                <div
                  className="thumbnail thumbnail-2"
                  data-sal-delay="500"
                  data-sal="slide-down"
                  data-sal-duration="1000"
                >
                  <img src="/images/cake_birthday.jpg" alt="" />
                </div>
                <div
                  className="online-support"
                  data-sal-delay="600"
                  data-sal="slide-right"
                  data-sal-duration="1000"
                >
                  <div className="inner">
                    <div className="content">
                      <span className="subtitle">INVITD</span>
                      <h4 className="title">
                        ONLINE INVITATION MAKER
                      </h4>
                    </div>
                  </div>
                </div>
                <ul className="shape-group">
                  <li
                    className="shape-2 scene"
                    data-sal-delay="1000"
                    data-sal="fade"
                    data-sal-duration="1000"
                  >
                    <img data-depth="-2" src="images/shape-12.png" alt="Shape" />
                  </li>
                  <li
                    className="shape-4 scene"
                    data-sal-delay="1000"
                    data-sal="fade"
                    data-sal-duration="1000"
                  >
                    <img data-depth="-2" src="images/shape-04.png" alt="Shape" />
                  </li>
                </ul>
              </div>
            </div>
            <img src="images/bg-image-1.png" alt="" className="platform-bg" />

            <div className="footer bg-footer-theme fcopyright  fs-13 text-center z-index">
              <div className="row">
                <div className="col-md-5">
                  ©{new Date().getFullYear()}, <a
                    href="https://ajsinnovations.in/"
                    className="text-primary"
                    target="_new"
                  >
                    AJS Innovations Pvt. Ltd.
                  </a> All Rights Reserved.
                </div>
                {/* <div className="col-md-7">
                  Software Powered By{" "}
                  <a
                    href=""
                    target="_blank"
                    className="footer-text text-primary fw-medium"
                  >
                    Edit Point India
                  </a>{" "}
                  Private Limited
                </div> */}
                {/* <div className="col-md-5">
                  Developed By{" "}
                  <a
                    href="https://ajsinnovations.in/"
                    className="text-primary"
                    target="_new"
                  >
                    AJS Innovations
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Left Text --> */}

        {/* <!-- Login --> */}
        <div className="d-flex col-12 col-lg-4 align-items-center p-sm-4 p-3">
          <div className="w-px-400 mx-auto">
            {/* <!-- Logo --> */}
            <div className="app-brand mx-6 mb-1">
              <a href={`${config.landingbaseurl}`}>
                <span className="app-brand-logo demo">
                  <img
                    src="images/logo.png"
                    className="img-fluid my-5 auth-illustration"
                  />
                </span>
              </a>
            </div>
            {/* <!-- /Logo --> */}
            <h3 className="mb-4 fw-bold text-center">ONLINE INVITATION MAKER</h3>

            <form
              id="formAuthentication"
              className="mb-3"
              onSubmit={handleRegistration}
            >
              <div className="mb-2">
                <label htmlFor="firstName" className="form-label">
                  First Name
                </label>
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                <input
                  type="text"
                  className="form-control"
                  id="firstName"
                  name="firstName"
                  placeholder="Enter Your First Name"
                  onChange={handleInputChange}
                  autoFocus
                  required
                />
              </div>
              <div className="mb-2">
                <label htmlFor="lastName" className="form-label">
                  Last Name
                </label>
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                <input
                  type="text"
                  className="form-control"
                  id="lastName"
                  name="lastName"
                  placeholder="Enter Your Last Name"
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="mb-2">
                <label htmlFor="lastName" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  name="email"
                  onChange={handleInputChange}
                  placeholder="Enter Your Email Address"
                  style={{ width: "100%" }}
                />
                {error.email && (
                  <div style={{ color: "red" }}>{error.email}</div>
                )}
              </div>

              <div className="mb-2">
                <label htmlFor="phoneNumber" className="form-label">
                  Phone Number
                </label>
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                <input
                  type="tel" pattern="[0-9]*"
                  className="form-control mb-2 no-arrows"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="Enter Your Phone Number"
                  onChange={handleInputChange}
                  required
                  maxLength="10"
                  value={formValues.phoneNumber}
                />

                {error.phoneNumber && (
                  <div style={{ color: "red" }}>{error.phoneNumber}</div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label" htmlFor="password">
                  Password
                </label>
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                <input
                  type="password"
                  id="password"
                  className="form-control mb-2"
                  name="password"
                  onChange={handleInputChange}
                  placeholder="Enter Your Password"
                  style={{ width: "100%" }}
                  required
                />

                {error.password && (
                  <div style={{ color: "red" }}>{error.password}</div>
                )}
              </div>
              <div className="mb-3">
                <div className="d-flex justify-content-between  align-items-center">
                  <div className="col-3 justify-content-center ">
                    <button
                      type="submit"
                      className="btn btn-primary d-grid w-30"
                    >
                      Sign Up
                    </button>
                  </div>
                  <div className=" ">
                    <a href="/login"
                      className="px-0 fs-14 border-none"
                      style={{ backgroundColor: 'transparent' }}
                    >
                      Already Have an Account?
                    </a>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 justify-content-center"></div>
              </div>
            </form>
          </div>
        </div>
      </div >

    </div >
  );
}
{/* <div className="mb-2">
<label className="form-label" htmlFor="studioName">
  Studio Name
  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
</label>
<input
  type="text"
  id="studioName"
  className="form-control"
  name="studioName"
  onChange={handleInputChange}
  placeholder="Enter Your Studio Name"
  required
/>
</div> */}